import React, { useCallback, useEffect, useMemo, useState } from 'react';

import Formsy from 'formsy-react';
import { ExternalLink, Plus, Trash } from 'lucide-react'
import { SelectMulti, Select as TWSelect, List, ListItem, Tabs, TabsList, TabsTrigger, TabsContent, Row, Col, Card, Button, Label, FormGroup, Badge, DefaultTooltip, SheetBody, SheetFooter, FormSection } from 'twyne-new.ui'

import FileUpload from '@/components/FileUpload';
import Input from 'components/form/Input';
import Select from 'components/form/Select';
import Switch, { PureSwitch } from 'components/form/Switch';
import appStore from 'stores/app';
import history from 'utils/history';

import { useRootfileStore } from '../store';

import { buildFileUrl } from './utils'

import { MIME_TYPES, MIME_TYPE_OPTIONS } from './mimeTypes'

export default class RootFileForm extends React.Component {
  state = {
    active: true,
    site_id: appStore.site.id,
    isLoadFile: false,
  }

  componentWillMount() {
    const { data } = this.props;
    if (data) {
      if (!MIME_TYPES.includes(data.content_type)) {
        MIME_TYPES.push(data.content_type);
        MIME_TYPE_OPTIONS.push({ label: data.content_type, value: data.content_type })
      }
      this.setState(data);
    }
  }

  handleValidSubmit = model => {
    this.props.handleSubmit(Object.assign(this.state, model));
  }

  handleCancel = () => {
    if (this.props.onCancel) {
      this.props.onCancel();
    } else {
      history.goBack();
    }
  }

  handleFileRemove = () => this.setState({ file: null, content_type: null })

  handleChangeMimeType = option => {
    const contentType = option ? option.value : null;
    this.setState({ content_type: contentType });
  }

  FileURLItem = ({ domain }) => {
    const href = buildFileUrl(this.state.path, domain)

    return <ListItem
      className='items-center gap-2'
      onClick={() => window.open(href, '_blank')}
    >
      <span className='truncate'>{href}</span>
      <ExternalLink size={14} className='shrink-0' />
    </ListItem>
  }

  FileURL = () => <Col size="12">
    <FormGroup>
      <Label>Link</Label>
      <List border className='px-0!'>
        <this.FileURLItem />
      </List>
    </FormGroup>
  </Col>

  FileDomainUploader = ({ options, data, onRemove, children }) => {
    const [domains, setDomains] = useState(data.domains || null)
    const [file, setFile] = useState(data.file || null)
    const [contentType, setContentType] = useState(data.content_type || null)

    const [loading, setLoading] = useState(false)
    const { upload } = useRootfileStore()

    useEffect(() => {
      data.domains = domains
    }, [domains, data])

    useEffect(() => {
      data.file = file
    }, [file, data])

    useEffect(() => {
      data.content_type = contentType
    }, [contentType, data])

    const handleFileUpload = async file => {
      setLoading(true)
      try {
        const { contentType, location } = await upload(file)

        if (!MIME_TYPES.includes(contentType)) {
          MIME_TYPES.push(contentType)
          MIME_TYPE_OPTIONS.push({ label: contentType, value: contentType })
        }

        setFile(location)
        setContentType(contentType)
      } catch (error) {
        //
      }
      setLoading(false)
    }

    const showUrls = !!this.state.id && !!domains?.length

    return <Row>
      <Col size="12">
        <FormGroup>
          <Label>Content Type</Label>
          {children}
          <TWSelect
            options={MIME_TYPE_OPTIONS}
            value={contentType}
            onChange={option => setContentType(option.value)}
          />
        </FormGroup>
      </Col>
      <Col size="12">
        <FormGroup>
          <Label>File</Label>
          <FileUpload
            onUpload={handleFileUpload}
            value={file}
            isLoading={loading}
            onRemove={onRemove}
          />
        </FormGroup>
      </Col>
      <Col size='12'>
        <FormGroup>
          <Label>Domain</Label>
          <SelectMulti
            value={domains}
            options={options}
            clearable={false}
            onChange={items => setDomains(items.map(item => item.value))}
          />
          {showUrls ? <>
            <Label className='mt-2'>Links</Label>
            <List border className='px-0!'>
              {domains.map(domain => <this.FileURLItem key={domain} domain={domain} />)}
            </List>
          </> : null}
        </FormGroup>
      </Col>
      <Col size="12">
        <div className='flex justify-end'>
          <Button
            onClick={onRemove}
            variant='outline'
            color='danger'
            size='sm'
            type='button'
          >
            <Trash size={14} />
            Remove
          </Button>
        </div>
      </Col>
    </Row>
  }

  FilesDomainsUploaders = () => {
    const [files, setFiles] = useState(this.state.meta?.files?.length ? this.state.meta.files : [{}])
    const [activeFile, setActiveFile] = useState('file-0')

    const domainsOtpions = useMemo(() => appStore.site.domain_aliases
      .split(',')
      .filter(domain => !domain.includes('*'))
      .map(domain => {
        domain = JSON.parse(domain)
        return {
          label: domain,
          value: domain,
        }
      }), [])

    useEffect(() => {
      this.setState({
        meta: {
          ...this.state.meta || {},
          files,
        },
      })
    }, [files])

    const handleAddFile = () => {
      setActiveFile(`file-${files.length}`)
      setFiles(current => [...current, {}])
    }

    const handleRemoveFile = file => {
      setActiveFile('file-0')
      setFiles(current => current.filter(item => item !== file))
    }

    return <Col size='12'>
      <Row>
        <Col size="12">
          <div className='float-right'>
            <Button
              color="accent"
              size="sm"
              onClick={handleAddFile}
            >
              <Plus size={14} />
              Add File
            </Button>
          </div>

          <FormSection>
            Files by domain
          </FormSection>
        </Col>
        <Col size="12">
          <Tabs value={activeFile} onValueChange={setActiveFile} forceMount>
            <TabsList>
              {files.map((file, idx) => <TabsTrigger className='pt-0' key={idx} value={`file-${idx}`}>
                File {idx + 1}
              </TabsTrigger>)}
            </TabsList>
            {files.map((file, idx) => <TabsContent key={idx} value={`file-${idx}`}>
              <Card className='pb-2'>
                <FormGroup>
                  <this.FileDomainUploader
                    data={file}
                    options={domainsOtpions}
                    onRemove={() => handleRemoveFile(file)}
                  >
                    {idx !== 0 ? null : <div className='float-right'>
                      <DefaultTooltip side='left' content='Default file is used when no domain is matched'>
                        <Badge className='mb-2' size='sm' color="accent">default</Badge>
                      </DefaultTooltip>
                    </div>}
                  </this.FileDomainUploader>
                </FormGroup>
              </Card>
            </TabsContent>)}
          </Tabs>
        </Col>
      </Row>
    </Col>
  }

  Uploader = () => {
    const { meta } = this.state;
    const [multipleDomains, setMultipleDomains] = useState(!!meta?.files)

    const handleChangeMultipleDomains = ({ target: { checked } }) => {
      setMultipleDomains(checked)
      if (!checked) {
        this.setState({ meta: null })
      }
    }

    return <>
      <Col size="3">
        <FormGroup>
          <Label>Multiple domains</Label>
          <PureSwitch
            value={multipleDomains}
            onChange={handleChangeMultipleDomains}
          />
        </FormGroup>
      </Col>
      {multipleDomains ? <this.FilesDomainsUploaders /> : <>
        <Col size="12">
          <FormGroup>
            <Label>Content Type</Label>
            <Select
              name="content_type"
              options={MIME_TYPE_OPTIONS}
              value={this.state.content_type || null}
              handleOnChange={this.handleChangeMimeType}
            />
          </FormGroup>
        </Col>
        <Col size="12">
          <FormGroup>
            <Label>File</Label>
            <this.FileUploader />
          </FormGroup>
        </Col>
      </>}
    </>
  }

  FileUploader = () => {
    const { upload } = useRootfileStore()

    const handleFileUpload = useCallback(async file => {
      try {
        this.setState({ isLoadFile: true })
        const data = await upload(file)

        if (!MIME_TYPES.includes(data.contentType)) {
          MIME_TYPES.push(data.contentType)
          MIME_TYPE_OPTIONS.push({ label: data.contentType, value: data.contentType })
        }

        this.setState({ file: data.location, content_type: data.contentType, isLoadFile: false })
      } catch (error) {
        console.log(error)
        this.handleFileRemove()
      }
    }, [])

    return <FileUpload
      type={null}
      onUpload={handleFileUpload}
      value={this.state.file}
      isLoading={this.state.isLoadFile}
      onRemove={this.handleFileRemove}
    />
  }

  render() {
    return (
      <Formsy onValidSubmit={this.handleValidSubmit}>
        <SheetBody>
          <Row>
            <Col size="7">
              <FormGroup>
                <Label>Slug</Label>
                <Input name="path" value={this.state.path || ''} required />
              </FormGroup>
            </Col>
            <Col size="2">
              <FormGroup>
                <Label>Active</Label>
                <Switch name="active" value={this.state.active || false} />
              </FormGroup>
            </Col>
            <this.Uploader />
            {this.state.id && !this.state.meta?.files ? <this.FileURL /> : null}
          </Row>
        </SheetBody>
        <SheetFooter>
          <Button onClick={this.handleCancel} variant='ghost'>Cancel</Button>
          <Button type="submit" color="accent">Save</Button>
        </SheetFooter>
      </Formsy>
    );
  }
}
